module.exports = __webpack_public_path__ + "img/simple_loader.70ee7075.gif";